export const getStoresForm = state => state.storesState.storesForm;
export const getStoreSpecialDiscounts = state => state.storesState.storesForm.storeSpecialDiscounts || [];
export const getStoreTicketSubjects  = state => state.storesState.storesForm.ticketSubjects  || [];
export const getLoading = state => state.storesState.isLoading;
export const getLoadingStores = state => state.storesState.isLoadingStores;
export const getStores = state => state.storesState.stores;
